import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-expandable-text',
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './expandable-text.component.html',
  styleUrl: './expandable-text.component.scss',
})
export class ExpandableTextComponent {
  readonly text = input.required<string>();
  private readonly maxLength = 250;

  protected readonly expanded = signal(false);

  protected readonly isLong = computed(() => this.text().length > this.maxLength);

  /** Az utolsó teljes szó vége maxLength karakteren belül — nem vág szót félbe. */
  private readonly splitIndex = computed(() => {
    const value = this.text();
    if (value.length <= this.maxLength) {
      return value.length;
    }
    const slice = value.slice(0, this.maxLength);
    const lastSpace = slice.lastIndexOf(' ');
    return lastSpace > 0 ? lastSpace : this.maxLength;
  });

  protected readonly visiblePart = computed(() => this.text().slice(0, this.splitIndex()));
  protected readonly restPart = computed(() => this.text().slice(this.splitIndex()));

  toggle(): void {
    this.expanded.update(v => !v);
  }
}
